// 设置带过期时间的存储
// key: 存储键名
// value: 要存储的数据（可以是任意可序列化类型）
// days: 有效天数（例如 7 表示 7 天后过期）
export function setWithExpiry(key, value, days) {
  const expiry = Date.now() + days * 24 * 60 * 60 * 1000;
  localStorage.setItem(key, JSON.stringify({ value, expiry }));
}

export function getWithExpiry(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    const { value, expiry } = JSON.parse(raw);
    if (Date.now() > expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return value;
  } catch {
    return null;
  }
}